import { useState } from 'react'

import { useTheme } from 'antd-style'

import { OcrLimitResult } from '@eastcoal/api/nexus/interface'
import { recognizeBusinessLicenseApi } from '@eastcoal/api/nexus/ocr/recognizeBusinessLicense'

import { UploadOcr } from '@eastcoal/common/components/UploadOcr'

import { OCrHelp } from '../OcrHelp'

import businessLicenseImg from './assets/businessLicense.jpg'
import { BusinessLicenseOcrProps } from './interface'

const imageStyle = {
  height: 150,
  width: 'auto'
}

export const OcrBusinessLicense = (props: BusinessLicenseOcrProps) => {
  const [limit, setLimit] = useState<OcrLimitResult>({
    rest: 0,
    total: 0
  })

  const theme = useTheme()

  return (
    <UploadOcr
      {...props}
      help={<OCrHelp limit={limit} title='营业执照' />}
      imageStyle={imageStyle}
      ocrApi={recognizeBusinessLicenseApi}
      style={{
        padding: theme.paddingXXS,
        textAlign: 'center'
      }}
      onLimitChange={setLimit}
    >
      <img alt='营业执照' src={businessLicenseImg} style={imageStyle} />
    </UploadOcr>
  )
}
